import { Card, CardContent } from "@/components/ui/card";
import { type ReactNode } from "react";

interface H1HeaderCardProps {
    title: string;
    subtitle?: string;
    className?: string;
    children?: ReactNode;
}

export function H1HeaderCard({
    title,
    subtitle,
    className = "",
    children,
}: H1HeaderCardProps) {
    return (
        <Card className={`w-full p-14 ${className}`}>
            <CardContent className="p-0">
                <h1 className="text-5xl  sm:text-6xl font-medium text-md-on-surface leading-tight tracking-tight">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-md-on-surface-variant leading-relaxed tracking-wide mt-2">
                        {subtitle}
                    </p>
                )}
                <p>&nbsp;</p>
                {children && (
                    <div className="text-sm text-md-on-surface-variant leading-relaxed tracking-wide mt-2">
                        {children}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
